var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#252342"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 0 0-8.486 20.485A12 12 0 0 0 24 12a12 12 0 0 0-3.518-8.481A12.01 12.01 0 0 0 12 0m0 22A10 10 0 0 1 4.929 4.929 10 10 0 0 1 22 12a10.01 10.01 0 0 1-10 10m.717-16.937A4 4 0 0 0 8 9a1 1 0 1 0 2 0 2 2 0 0 1 2.371-1.967 2.03 2.03 0 0 1 1.6 1.595 2 2 0 0 1-1 2.125A3.95 3.95 0 0 0 11 14.257V15a1 1 0 1 0 2 0v-.743a1.98 1.98 0 0 1 .93-1.752 4 4 0 0 0-1.213-7.442M13 18a1 1 0 1 0-2 0 1 1 0 1 0 2 0"
  })));
};
export default SvgQuestionMark;